import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { useState } from 'react';
import { registerArtifact } from './lib/artifacts/registry';
// Artifact registration
import { sheetArtifact } from './lib/artifacts/sheet/client';
import { textArtifact } from './lib/artifacts/text/client';
/**
 * Initialize artifact definitions
 * Register all available artifact types so they can be dynamically loaded in the editor
 * Done outside window check so it runs in both browser and test environments
 */ registerArtifact(textArtifact);
registerArtifact(sheetArtifact);
/**
 * Initialize PostHog analytics on the client side
 * Only initializes if both NEXT_PUBLIC_POSTHOG_KEY and NEXT_PUBLIC_POSTHOG_HOST are set
 */ if (typeof window !== 'undefined') {
    const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
    const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST;
    if (posthogKey && posthogHost) {
        posthog.init(posthogKey, {
            api_host: posthogHost,
            person_profiles: 'identified_only'
        });
    }
}
/**
 * Custom PostHog provider component for analytics
 * Wraps the PostHog provider with the initialized client
 */ export function CSPostHogProvider({ children }) {
    return /*#__PURE__*/ _jsx(PostHogProvider, {
        client: posthog,
        children: children
    });
}
/**
 * React Query provider with configured QueryClient
 * Creates a new QueryClient instance per component tree to avoid sharing state between different instances
 */ export function ReactQueryProvider({ children }) {
    const [queryClient] = useState(()=>new QueryClient({
            defaultOptions: {
                queries: {
                    staleTime: 60 * 1000,
                    retry: 1,
                    refetchOnWindowFocus: false
                }
            }
        }));
    return /*#__PURE__*/ _jsx(QueryClientProvider, {
        client: queryClient,
        children: children
    });
}
